import { render, staticRenderFns } from "./SaveDocumentState.vue?vue&type=template&id=620121f8&scoped=true&"
import script from "./SaveDocumentState.vue?vue&type=script&lang=js&"
export * from "./SaveDocumentState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620121f8",
  null
  
)

export default component.exports